import { CampaignProduct } from "../dto/campaign-product.model";

	/**
	 * @description
	 *  Modelo de un producto en una nota de CyR o NC, sobre un pedido.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/OrderEventProductsForGet.cs
	 */

export class OrderEventProductsForGet {

	public campaignProductReturnId: number;
	public code: string;
	public id: number;
	public name: string;
	public orderEventId: number;
	public price: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un producto de una nota con una semántica vacía. Nótese que
	 *	no es lo mismo que construir un producto con valores por defecto. Las
	 *	reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un producto en una nota de CyR/NC vacío.
	 */
	public static empty(): OrderEventProductsForGet {
		const orderEventProductsForGet: OrderEventProductsForGet = new OrderEventProductsForGet();
		orderEventProductsForGet.campaignProductReturnId = undefined;
		orderEventProductsForGet.code = "";
		orderEventProductsForGet.id = undefined;
		orderEventProductsForGet.name = "";
		orderEventProductsForGet.orderEventId = undefined;
		orderEventProductsForGet.price = undefined;
		orderEventProductsForGet.quantity = undefined;
		return orderEventProductsForGet;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventProductsForGet
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventProductsForGet: OrderEventProductsForGet): OrderEventProductsForGet {
		if (!anemicOrderEventProductsForGet) return undefined;
		const orderEventProductsForGet: OrderEventProductsForGet = OrderEventProductsForGet.empty();
		orderEventProductsForGet.campaignProductReturnId = anemicOrderEventProductsForGet.campaignProductReturnId;
		orderEventProductsForGet.code = anemicOrderEventProductsForGet.code;
		orderEventProductsForGet.id = anemicOrderEventProductsForGet.id;
		orderEventProductsForGet.name = anemicOrderEventProductsForGet.name;
		orderEventProductsForGet.orderEventId = anemicOrderEventProductsForGet.orderEventId;
		orderEventProductsForGet.price = anemicOrderEventProductsForGet.price;
		orderEventProductsForGet.quantity = anemicOrderEventProductsForGet.quantity;
		return orderEventProductsForGet;
	}

	/**
	 * @description
	 *	Crea una nueva instancia de un producto de campaña desde este modelo.
	 *	Nótese que debido a la conversión, el campo 'quantity' se pierde y
	 *	debe almacenarse fuera del objeto.
	 *
	 * @returns
	 *	Una vista de este modelo como CampaignProduct.
	 */
	public asCampaignProduct(): CampaignProduct {
		const campaignProduct = CampaignProduct.empty();
		campaignProduct.id = this.campaignProductReturnId;
		campaignProduct.price = this.price;
		campaignProduct.product.code = this.code;
		campaignProduct.product.name = this.name;
		return campaignProduct;
	}

	/**
	 * @description
	 *	Computa el precio de folleto de este ítem.
	 *
	 * @returns
	 *	El precio de folleto total para este ítem.
	 */
	public totalBrochurePrice(): number {
		return this.quantity * this.price;
	}
}
